/**
 * Exact regex literal escaping shared by Core and browser search callers.
 * DOCUMENTED EXCEPTION: pure leaf; callers own gates, coercion and error reporting.
 * Invalid inputs and native replace/getter faults intentionally propagate.
 */
export class kRegexStringCore {
    public static Escape = (Value: string): string => {
        return Value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
}
